export default __webpack_public_path__ + "267cd6ed8e6268e27e2fa9c16aeff6ee.png";